/* eslint-disable*/
import React, { useState, useEffect } from 'react';
import {
  Grid,
  TextField,
  Typography,
  Box,
  Button,
  Link,
  InputLabel,
  Container,
  InputAdornment,
  Checkbox,
  Chip,
} from '@material-ui/core';
import { Formik, Form, FastField, useFormik } from 'formik'; // Import useFormik
import Autocomplete from '@material-ui/lab/Autocomplete';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { ReactComponent as MapPinIcon } from '../../../../assets/images/map-pin.svg';
import { ReactComponent as PhoneIcon } from '../../../../assets/images/PhoneIcon.svg';
import { ReactComponent as WebsiteIcon } from '../../../../assets/images/WebsiteIcon.svg';
import useCommunityList from '../../../../hooks/useCommunityList';
import { useNavigate, useParams, useLocation } from 'react-router';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import NumberFormat from 'react-number-format';
import FacilityDeleteModal from '../CommunityHealthFacility/FacilityDeleteModal';
import ModalEditViewDelete from '../../ModalEditViewDelete/ModalEditViewDelete';
import * as Yup from 'yup';
import { FACILITY_TYPES } from '../../../../constants/globalConstants';
import { phoneRegex, urlRegex } from '../../../../constants/regex';

//const facilityTypeOptions = FACILITY_TYPES?.map((facilityType) => ({ title: facilityType }));
/* const facilityTypeOptions = [
  // Define your facility type options
  { title: 'Assisted Living Facility' },
  { title: 'Behavioral Health Facility' },
  { title: 'Home Healthcare' },
  { title: 'Hospice Services' },
  { title: 'Hospital - General Acute Care' },
  { title: 'Hospital - Specialty Care' },
  { title: 'Long Term Care Facility' },
  { title: 'Outpatient Specialty Care Facility' },
  // Add more options as needed
]; */

const CommunityAddHealthFacility = () => {
  const navigate = useNavigate();
  const location = useLocation();
  //console.log(isEdit, 'EM');
  const [isAccessible, setIsAccessible] = React.useState('');

  // Checkbox icons for Autocomplete
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const {
    addCommunityHealthFacility,
    getCommunityHealthFacility,
    updateCommunityHeathFacility,
    getHealthFacilityTypes,
  } = useCommunityList();

  const params = useParams();
  const [isEdit, setIsEdit] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [getFacilityId, setFacilityId] = useState(null);
  const [compRepId, setCompRepId] = useState(null);
  const [facilityTypeOptions, setFacilityTypeOptions] = useState([]);

  // Get facility data from navigation state (passed from HealthCare.js)
  const facilityDataFromState = location.state?.facilityData;

  //console.log(compRepId && compRepId[0] && compRepId[0].repId, 'compRepId');

  const key = 'iFrasCwdJh';
  let bytes = null;

  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } else {
    window.location.hash = '#/app/home-page';
  }

  const handleBackToParent = (e) => {
    e.preventDefault();
    console.log('Back button clicked - Form dirty state:', formik.dirty);
    console.log('Form values:', formik.values);
    console.log('Initial values:', formik.initialValues);
    if (formik.dirty) {
      console.log('Form has unsaved changes - showing confirmation dialog');
      setShowDeleteBox1(true);
    } else {
      console.log('Form has no changes - navigating back');
      navigate(`/app/community-details/${params.id}#Section11`);
    }
  };

  const onTakeMeback = () => {
    setShowDeleteBox1(false);
  };

  const fetchData = async () => {
    try {
      // If facility data was passed from navigation state, use it directly
      if (facilityDataFromState) {
        console.log('Using facility data from navigation state:', facilityDataFromState);
        console.log('TypeIds from state:', facilityDataFromState?.typeIds);
        setInitialValues(facilityDataFromState);
        return;
      }

      // Otherwise, fetch from API (fallback for direct URL access)
      const response = await getCommunityHealthFacility({
        communityId: params?.id,
        // repId: compRepId && compRepId[0] && compRepId[0].repId,
        facilityId: params?.facilityId,
      });
      console.log('Fetched facility data from API:', response.data[0]);
      console.log('TypeIds from API response:', response.data[0]?.typeIds);
      // Assuming the response contains an array of health facilities
      setInitialValues(response.data[0]);

      //
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getFacilityType = async () => {
    const facilityType = await getHealthFacilityTypes();
    console.log(facilityType, 'facilityType');
    setFacilityTypeOptions(facilityType?.data);
    // console.log(facilityType, 'facilityType');
  };

  useEffect(() => {
    getFacilityType();
    setIsEdit(params.facilityId != undefined ? true : false);
    if (compRepId && compRepId[0] && compRepId[0].repId) {
      setIsEdit(params.facilityId != undefined ? true : false);
      if (params.facilityId) {
        fetchData();
      } else {
        setInitialValues({
          facilityType: '', // Add the default value if not present in the response
          // other fields...
        });
      }
    } else {
      // Log a message or handle accordingly when compRepId is not yet available
      //console.log('Waiting for compRepId to be available...');
    }
  }, [compRepId, params?.id, params?.facilityId]);
  //console.log(initialValues, 'HFHF');

  useEffect(() => {
    console.log('isEdit:', isEdit, params);
    fetchData(); // Call the fetchData function when the component mounts
  }, [params?.facilityId, facilityDataFromState]);

  const handleSubmit = (values) => {
    console.log('=== FORM SUBMIT ===');
    console.log('Form values:', values);

    if (values.facilityPhone === '') {
      // If empty, set it to null
      values.facilityPhone = null;
    }

    // Prepare the payload with facilityTypeIds array
    const payload = {
      ...values,
      facilityTypeIds: values.facilityTypes, // Send array of type IDs
      facilityTypeId: values.facilityTypes[0], // First type for backward compatibility
    };

    // Remove the facilityTypes field as backend expects facilityTypeIds
    delete payload.facilityTypes;

    console.log('Payload to be sent to backend:', payload);
    console.log('Required fields check:', {
      communityId: !!payload.communityId,
      repId: !!payload.repId,
      //facilityName: !!payload.facilityName,
      //facilityAddress: !!payload.facilityAddress,
      facilityTypeIds: payload.facilityTypeIds,
      facilityTypeId: payload.facilityTypeId,
    });

    if (isEdit) {
      // Handle update logic here
      payload['isAdminEntry'] = Boolean(loggedInUserData?.roleId === 2);
      updateCommunityHeathFacility(initialValues.id, payload)
        .then((response) => {
          console.log('Update facility response:', response);
          console.log('Response type:', typeof response);
          console.log('Response.status:', response?.status);

          // Check if response is valid and successful
          // Success response should have status: true
          if (!response || response.status === false || response instanceof Error) {
            const errorMessage =
              response?.message || 'Failed to update facility. Please check all required fields.';
            console.error('Update failed:', errorMessage);
            alert(errorMessage);
            return; // Stay on the page
          }

          // Handle success - navigate away
          console.log('Updated facility successfully');
          setTimeout(() => {
            navigate(`../../../community-details/${params?.id}#Section11`);
          }, 300);
        })
        .catch((error) => {
          // Handle error - this catches network errors and rejected promises
          console.error('Error updating facility - caught in catch:', error);
          console.log('Error type:', typeof error);
          console.log('Error.status:', error?.status);
          console.log('Error.message:', error?.message);

          // Error can be the full response object with {status: false, message: "..."}
          const errorMessage =
            error?.message || 'An error occurred while updating the facility. Please try again.';
          alert(errorMessage);
        });
    } else {
      // Handle add logic here
      payload['isAdminEntry'] = Boolean(loggedInUserData?.roleId === 2);
      console.log('Add facility payload:', payload);
      addCommunityHealthFacility(payload)
        .then((response) => {
          console.log('Add facility response:', response);
          console.log('Response type:', typeof response);
          console.log('Response.status:', response?.status);

          // Check if response is valid and successful
          // Success response should have status: true
          if (!response || response.status === false || response instanceof Error) {
            const errorMessage =
              response?.message || 'Failed to add facility. Please check all required fields.';
            console.error('Add failed:', errorMessage);
            //alert(errorMessage);
            return; // Stay on the page
          }

          // Handle success - navigate away
          console.log('Added facility successfully');
          setTimeout(() => {
            navigate(`../../community-details/${params?.id}#Section11`);
          }, 1000);
        })
        .catch((error) => {
          // Handle error - this catches network errors and rejected promises
          console.error('Error adding facility - caught in catch:', error);
          console.log('Error type:', typeof error);
          console.log('Error.status:', error?.status);
          console.log('Error.message:', error?.message);

          // Error can be the full response object with {status: false, message: "..."}
          const errorMessage =
            error?.message || 'An error occurred while adding the facility. Please try again.';
          alert(errorMessage);
        });
    }
  };

  const [formattedPhone, setFormattedPhone] = useState(
    isEdit ? initialValues?.facilityPhone || '' : '',
  );

  const validationSchema = Yup.object().shape({
    facilityTypes: Yup.array()
      .min(1, 'At least one Facility Type is required')
      .required('Facility Type is required'),
    facilityName: Yup.string().required('Facility Name is required'),
    facilityAddress: Yup.string().required('Facility Address is required'),
    facilityPhone: Yup.string()
      .nullable()
      // .matches(/^\d{10}$/, 'Phone Number must be 10 digits'),
      .matches(phoneRegex, 'Not a valid phone number'),
    facilityWebUrl: Yup.string()
      .matches(urlRegex, 'Facility URL must be in a valid format.')
      .nullable(),
  });

  const handlePhoneChange = (event) => {
    const inputPhoneNumber = event.target.value;
    // Remove all non-numeric characters from the input
    const cleanedPhoneNumber = inputPhoneNumber.replace(/\D/g, '');

    // Limit the phone number to 10 digits
    const truncatedPhoneNumber = cleanedPhoneNumber.slice(0, 10);

    // Format the phone number as (XXX) XXX-XXXX
    const formattedPhoneNumber = truncatedPhoneNumber.replace(
      /(\d{3})(\d{3})(\d{4})/,
      '($1) $2-$3',
    );

    // Update the state with the formatted phone number
    setFormattedPhone(formattedPhoneNumber);

    // Update Formik's field value with the cleaned phone number (without formatting)
    formik.setFieldValue('facilityPhone', truncatedPhoneNumber);
  };
  // Initialize useFormik hook
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      communityId: params?.id,
      facilityId: params?.facilityId,
      repId: loggedInUserData?.id,
      facilityTypes: isEdit && initialValues?.typeIds ? initialValues.typeIds : [], // Initialize with array of type IDs
      facilityName: isEdit ? initialValues?.facilityName : '',
      facilityAddress: isEdit ? initialValues?.facilityAddress : '',
      facilityPhone: isEdit ? initialValues?.facilityPhone : '', // Initialize with an empty string
      facilityWebUrl: isEdit ? initialValues?.facilityWebUrl : '',

      // Add other fields here
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  // Debug log to verify form values and dirty state
  useEffect(() => {
    console.log('Form state updated:', {
      isEdit,
      dirty: formik.dirty,
      touched: formik.touched,
      facilityTypes: formik.values.facilityTypes,
      initialValuesTypeIds: initialValues?.typeIds,
      facilityTypeOptions: facilityTypeOptions.length,
    });
  }, [
    formik.dirty,
    formik.values.facilityTypes,
    formik.touched,
    initialValues,
    facilityTypeOptions,
  ]);
  //console.log(isEdit, 'EMEME');
  useEffect(() => {
    if (isEdit && initialValues && initialValues.facilityPhone) {
      // Format the phone number as (XXX) XXX-XXXX
      const formattedPhoneNumber = initialValues.facilityPhone.replace(
        /(\d{3})(\d{3})(\d{4})/,
        '($1) $2-$3',
      );
      setFormattedPhone(formattedPhoneNumber);
    }
  }, [isEdit, initialValues]);

  const [showDeleteBox, setShowDeleteBox] = useState(false);

  const [showDeleteBox1, setShowDeleteBox1] = useState(false);

  const openModal = () => {
    setShowDeleteBox(true);
    setFacilityId(params?.facilityId);
  };

  //console.log(getFacilityId, 'GETFD');

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSuccessfulDelete = () => {
    // This function will be called when the delete operation is successful
    // You can trigger any necessary actions here
    // For example, fetching data if needed
    fetchData();
  };

  useEffect(() => {
    loggedInUserData?.roleId === 1 || loggedInUserData?.roleId === 2
      ? setIsAccessible(true)
      : setIsAccessible(false);
  }, [loggedInUserData]);

  return (
    <Container>
      {isAccessible ? (
        <>
          <Box className="PageSpacing FixedMD CommunityAddHealthFacility">
            {showDeleteBox1 && (
              <>
                <ModalEditViewDelete
                  status={true}
                  navigateUrl={`/app/community-details/${params.id}#Section11`}
                  onClose={onTakeMeback}
                ></ModalEditViewDelete>
              </>
            )}
            <Grid container>
              <Grid item xs={12}>
                <Link
                  underline="none"
                  onClick={(e) => {
                    handleBackToParent(e);
                  }}
                  className="BackButtonWrapper"
                >
                  <Typography className="BackButton" variant="body1">
                    <ArrowBackIcon color="primary" className="BackButtonArrow" />
                    {isEdit ? 'Edit Facility' : 'Add Facility'}
                  </Typography>
                </Link>
              </Grid>
            </Grid>
            <Grid container className="FixedID">
              <Grid item xs={12}>
                <Formik
                  enableReinitialize={true} // Allow form reinitialization
                  initialValues={formik.values} // Use formik.values for initialization
                  onSubmit={formik.handleSubmit} // Use formik.handleSubmit for submission
                >
                  {() => (
                    <Form>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} className="commonFieldBox">
                          <InputLabel className="InputLabelFld" htmlFor="facilityTypes">
                            Type
                          </InputLabel>

                          <Autocomplete
                            limitTags={1}
                            className="CommonAutocomplete MultiSelect"
                            id="facilityTypes"
                            multiple={true}
                            disableCloseOnSelect
                            options={facilityTypeOptions}
                            getOptionLabel={(option) => option.facilityType}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select Facility Types"
                                label=""
                                variant="outlined"
                                error={
                                  formik.touched.facilityTypes &&
                                  Boolean(formik.errors.facilityTypes)
                                }
                                helperText={
                                  formik.touched.facilityTypes && formik.errors.facilityTypes
                                }
                              />
                            )}
                            value={(() => {
                              const selectedOptions = facilityTypeOptions.filter((option) =>
                                formik.values.facilityTypes.includes(option.id),
                              );
                              console.log('Autocomplete value:', {
                                facilityTypes: formik.values.facilityTypes,
                                selectedOptions: selectedOptions.map((o) => o.facilityType),
                                allOptions: facilityTypeOptions.length,
                              });
                              return selectedOptions;
                            })()}
                            onChange={(_, newValue) => {
                              console.log('Autocomplete onChange:', {
                                newValue: newValue.map((v) => ({
                                  id: v.id,
                                  type: v.facilityType,
                                })),
                              });
                              // Extract IDs from selected options
                              const selectedIds = newValue.map((item) => item.id);
                              formik.setFieldValue('facilityTypes', selectedIds);
                            }}
                            renderOption={(option, { selected }) => (
                              <li>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  checked={selected}
                                  className="AutocompleteCheckbox"
                                />
                                {option.facilityType}
                              </li>
                            )}
                            renderTags={(value, getTagProps) => {
                              const displayedTags = value.slice(0, 1);
                              const hiddenTagsCount = value.length - displayedTags.length;

                              return (
                                <>
                                  {displayedTags.map((option, index) => (
                                    <Chip
                                      key={index}
                                      label={option.facilityType}
                                      {...getTagProps({ index })}
                                    />
                                  ))}
                                  {hiddenTagsCount > 0 && (
                                    <Box className="TagsCounter">{`+${hiddenTagsCount}`}</Box>
                                  )}
                                </>
                              );
                            }}
                            popupIcon={<KeyboardArrowDownIcon />}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} className="commonFieldBox">
                          <InputLabel className="InputLabelFld" htmlFor="facilityName">
                            Facility Name
                          </InputLabel>
                          <FastField
                            as={TextField}
                            name="facilityName"
                            id="facilityName"
                            variant="outlined"
                            type="text"
                            fullWidth
                            onChange={(event) => {
                              formik.setFieldValue('facilityName', event.target.value); // Update facilityName
                            }}
                          />
                          {/* {formik.errors.facilityName && formik.touched.facilityName && (
                        <div className="ErrorMessage">{formik.errors.facilityName}</div>
                      )} */}
                        </Grid>
                        <Grid item xs={12} sm={6} className="commonFieldBox">
                          <InputLabel className="InputLabelFld" htmlFor="facilityAddress">
                            Address
                          </InputLabel>
                          <FastField
                            as={TextField}
                            name="facilityAddress"
                            id="facilityAddress"
                            variant="outlined"
                            type="text"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <MapPinIcon />
                                </InputAdornment>
                              ),
                            }}
                            fullWidth
                            onChange={(event) => {
                              formik.setFieldValue('facilityAddress', event.target.value); // Update facilityAddress
                            }}
                          />
                          {/* {formik.errors.facilityAddress && formik.touched.facilityAddress && (
                        <div className="ErrorMessage">{formik.errors.facilityAddress}</div>
                      )} */}
                        </Grid>
                        <Grid item xs={12} sm={6} className="commonFieldBox">
                          <Box display="flex" justifyContent="space-between">
                            <InputLabel className="InputLabelFld" htmlFor="facilityPhone">
                              Phone Number
                            </InputLabel>
                            <Typography variant="caption" component="div">
                              Optional
                            </Typography>
                          </Box>
                          <TextField
                            name="facilityPhone"
                            id="facilityPhone"
                            variant="outlined"
                            type="text"
                            fullWidth
                            value={formattedPhone}
                            onChange={handlePhoneChange}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <PhoneIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                          {formik.errors.facilityPhone && formik.touched.facilityPhone && (
                            <div className="ErrorMessage">{formik.errors.facilityPhone}</div>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box display="flex" justifyContent="space-between">
                            <InputLabel className="InputLabelFld" htmlFor="facilityWebUrl">
                              Website{' '}
                              <Typography component="span" variant="body2">
                                <Box component="span" fontWeight="600">
                                  (Enter URL)
                                </Box>
                              </Typography>
                            </InputLabel>
                            <Typography variant="caption" component="div">
                              Optional
                            </Typography>
                          </Box>
                          <FastField
                            as={TextField}
                            name="facilityWebUrl"
                            id="facilityWebUrl"
                            variant="outlined"
                            type="text"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <WebsiteIcon />
                                </InputAdornment>
                              ),
                            }}
                            fullWidth
                            onChange={(event) => {
                              formik.setFieldValue('facilityWebUrl', event.target.value || ''); // Update facilityWebUrl
                            }}
                          />
                          {formik.errors.facilityWebUrl && formik.touched.facilityWebUrl && (
                            <div className="ErrorMessage">{formik.errors.facilityWebUrl}</div>
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          <Box className="Wrapper ButtonWrapper">
                            {console.log('Button disabled state:', {
                              hasFacilityTypes: !!formik.values.facilityTypes,
                              facilityTypesLength: formik.values.facilityTypes?.length,
                              hasFacilityName: !!formik.values.facilityName,
                              hasFacilityAddress: !!formik.values.facilityAddress,
                              isDirty: formik.dirty,
                              isDisabled:
                                !formik.values.facilityTypes ||
                                formik.values.facilityTypes.length === 0 ||
                                !formik.values.facilityName ||
                                !formik.values.facilityAddress ||
                                !formik.dirty,
                            })}
                            <Button
                              disabled={
                                !formik.values.facilityTypes ||
                                formik.values.facilityTypes.length === 0 ||
                                !formik.values.facilityName ||
                                !formik.values.facilityAddress ||
                                !formik.dirty
                              }
                              variant="contained"
                              color="primary"
                              type="submit"
                              // onClick={updateFacility}
                              className="EditViewButton"
                              fullWidth
                            >
                              {isEdit ? 'Update' : 'Publish'}
                            </Button>
                          </Box>
                          {/* Add Delete Facility button */}
                          <Box component="div" display="flex" justifyContent="center">
                            {isEdit ? (
                              <>
                                <>
                                  <Button
                                    onClick={openModal}
                                    underline="none"
                                    className="DeleteAmenityButton LinkTypeButton RedLineButton"
                                    color="secondary"
                                    variant="text"
                                  >
                                    Delete Facility
                                  </Button>
                                </>
                                {showDeleteBox && (
                                  <FacilityDeleteModal
                                    open={isModalOpen}
                                    onCloseParent={closeModal}
                                    setShowDeleteBox={setShowDeleteBox}
                                    getFacilityId={getFacilityId}
                                    fetchData={fetchData}
                                    onSuccessfulDelete={handleSuccessfulDelete}
                                    // other props...
                                  />
                                )}

                                {/* Add Delete Facility button */}
                              </>
                            ) : (
                              ''
                            )}
                          </Box>
                        </Grid>

                        {/* <FacilityDeleteModal></FacilityDeleteModal> */}
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : (
        'You do not have permissions to access this url.'
      )}
    </Container>
  );
};

export default CommunityAddHealthFacility;
